import axios from "axios";

export const getTimeSheetTree = (
  id,
  partner,
  combination,
  clients,
  clientGroups,
  collaborators,
  types,
  periodUnit,
  periods,
  searchWord,
  clientCRMTypes,
  clientCRMGroup,
  deletedStatus
) => {
  const requestUrl = `/team/time-sheet`;

  let params = {
    organizationId: id,
    partner,
    searchWord: searchWord,
    clients: clients.map(({ value }) => value),
    clientGroups,
    collaborators: collaborators.map(({ value }) => value),
    types,
    periodUnit,
    periods,
    cycle: combination,
    clientCRMTypes: clientCRMTypes,
    clientCRMGroup: clientCRMGroup,
    deletedStatus: deletedStatus
  };

  return axios.get(requestUrl, {
    params
  });
};

export const importTimeSheet = ({
  config,
  timeSheetAttachment,
  data,
  forcedImport
}) => {
  const requestUrl = `/team/time-sheet/import`;

  var formData = new FormData();

  formData.append("config", config);
  formData.append("organizationId", data);
  formData.append("forcedImport", forcedImport);

  if (timeSheetAttachment instanceof File) {
    formData.append("file", timeSheetAttachment, timeSheetAttachment.name);
  }

  return axios.post(requestUrl, formData);
};

export const fetchLastTaskByUser = (uid, organizationId) => {
  const requestUrl = `/team/last-activities`;
  let params = {
    uid,
    organization: organizationId
  };

  return axios.get(requestUrl, {
    params
  });
};

export const exportPeriodTimeSheet = (
  id,
  combination,
  clients,
  clientGroups,
  collaborators,
  types,
  periodUnit,
  periods,
  searchWord,
  clientCRMTypes,
  clientCRMGroup,
  deletedStatus
) => {
  const requestUrl = `/team/export/time-sheet`;

  let params = {
    organizationId: id,
    searchWord: searchWord,
    clients: clients.map(({ value }) => value),
    clientGroups,
    collaborators: collaborators.map(({ value }) => value),
    types,
    periodUnit,
    periods,
    cycle: combination,
    clientCRMTypes: clientCRMTypes,
    clientCRMGroup: clientCRMGroup,
    deletedStatus: deletedStatus
  };

  return axios
    .get(requestUrl, {
      params,
      responseType: "blob",
      headers: { Accept: "application/vnd.ms-excel" }
    })
    .then(response => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.data.type })
      );
      const link = document.createElement("a");
      link.href = url;
      let date = new Date();
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let dateString =
        day +
        "-" +
        month +
        "-" +
        date.getFullYear() +
        " " +
        date.getHours() +
        "-" +
        minutes +
        "-" +
        seconds;
      link.setAttribute(
        "download",
        "PowerTeam Financial-sheet " + dateString + ".xlsx"
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};



// WEBPACK FOOTER //
// ./src/api/time-sheet.js